// Bootstrap module imported FIRST in index.js so Sentry hooks into uncaught errors
// before anything else loads.
import { initSentry } from './sentry';
initSentry();
